import React, { useState } from "react";
import styled from "styled-components";
import { Lightbox } from "../components";

const MatchDraft = ({ match, divisionName }) => {
  // eslint-disable-next-line
  const [matchInfo, setMatchInfo] = useState(match);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const images = [
    "https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/map_pool_t7.png",
  ];

  const template = `${matchInfo.playerAusername} || 0 - 0 || ${
    matchInfo.playerBusername
  } ${divisionName ? ` (${divisionName})` : ""}
Draft de mapas: https://www.aoe2cm.net/spectate/xxxxxx
Draft de civis: https://www.aoe2cm.net/spectate/xxxxxx

Mapa 1: xxxxx
Civ ${matchInfo.playerAusername}: xxxxx
Civ ${matchInfo.playerBusername}: xxxxx
Ganador: || xxxxx ||

Mapa 2: xxxxx
Civ ${matchInfo.playerAusername}: xxxxx
Civ ${matchInfo.playerBusername}: xxxxx
Ganador: || xxxxx ||

Mapa 3: xxxxx
Civ ${matchInfo.playerAusername}: xxxxx
Civ ${matchInfo.playerBusername}: xxxxx
Ganador: || xxxxx ||`;

  const [matchTemplate, setMatchTemplate] = useState(template);

  return (
    <Wrapper>
      <div className="column">
        <h2>INFO ÚTIL</h2>
        <p>Info que te puede ser útil:</p>
        <div className="usefull-info">
          <div
            className="usefull-info-image"
            onClick={() => {
              console.log("isOpen");
              setIsOpen(true);
            }}
          >
            <span>Pool mapas</span>
            <figure>
              <img
                src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/map_pool_t7.png"
                alt="pool mapas"
              />
            </figure>
          </div>

          <a
            href="https://docs.google.com/document/d/14ztVrO-8fSY5Mfn_tHre5ueHB7WSZBIq/edit?usp=sharing&ouid=101891344918082115048&rtpof=true&sd=true"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn space-around">Handbook</button>
          </a>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % images.length)
            }
          />
        )}

        <h2>ANTES DE EMPEZAR...</h2>
        <p>Aquí tienes un resumen de los pasos que debes realizar:</p>
        <article>
          <span>
            <b>1º Draft de mapas</b>
          </span>
          <p className="draft-link">
            <a
              href="https://aoe2cm.net/preset/apulb"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="icon"
                src="https://www.aoe2cm.net/images/aoe2cm2.png"
                alt="Draft de mapas"
              />
              Draft de mapas
            </a>
            (Anfitrión: {matchInfo.playerAusername}; Invitado:{" "}
            {matchInfo.playerBusername})
          </p>
        </article>
        <article>
          <span>
            <b>2º Draft de civis</b>
          </span>

          <p className="draft-link">
            <a
              href="https://www.aoe2cm.net/preset/lDOuj"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="icon"
                src="https://www.aoe2cm.net/images/aoe2cm2.png"
                alt="Draft de mapas"
              />
              Draft de civis
            </a>
            (Anfitrión: {matchInfo.playerAusername}; Invitado:{" "}
            {matchInfo.playerBusername})
          </p>
        </article>

        <h2>AL JUGAR...</h2>
        <article>
          <div className="infoBox" style={{ fontSize: "1rem" }}>
            Orden de juego de los mapas:
            <ul>
              <li>1º) HM de {matchInfo.playerAusername}</li>
              <li>2º) HM de {matchInfo.playerBusername}</li>
              <li>3º) Último mapa elegido por descarte</li>
            </ul>
          </div>
          <div className="infoBox" style={{ fontSize: "1rem" }}>
            Temas a tener en cuenta IMPORTANTES:
            <ul>
              <li>&gt; Acordaros de poner la partida PÚBLICA</li>
              <li>
                &gt; Acordaros de uniros a un canal de voz de la liga. Es
                OBLIGATORIO
              </li>
            </ul>
          </div>
        </article>

        <h2>DESPUÉS DE JUGAR...</h2>
        <article>
          <p>
            Una vez hayais terminado de jugar,{" "}
            <b>{matchInfo.playerAusername}</b> debe subir al canal de discord
            las recs y reportar los resultados. Utiliza la siguiente plantilla:
          </p>
        </article>
      </div>
      <textarea
        className="textarea-field-large"
        type="text"
        placeholder="Plantilla reportar resultado"
        value={matchTemplate}
        name="plantilla"
        onChange={(event) => {
          console.log("hola");
          setMatchTemplate(event.target.value);
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .usefull-info {
    display: flex;
    margin-bottom: 3rem;
    justify-content: center;
    align-items: center;
  }
  .usefull-info span {
    font-size: 1rem;
  }
  .usefull-info-image {
    cursor: pointer;
  }
  .usefull-info-image figure {
    margin-right: 2rem;
    position: relative;
    overflow: hidden;
    width: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .usefull-info-image img {
    width: 10rem;
  }
  .usefull-info-image figure::before {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    display: block;
    content: "";
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 100%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  .usefull-info-image figure:hover::before {
    -webkit-animation: circle 0.75s;
    animation: circle 0.75s;
  }
  @-webkit-keyframes circle {
    0% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    100% {
      width: 200%;
      height: 200%;
      opacity: 0;
    }
  }
  @keyframes circle {
    0% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    100% {
      width: 200%;
      height: 200%;
      opacity: 0;
    }
  }

  .textarea-field-large {
    background: transparent;
    width: 100%;
    height: 300px;
    border: 1px solid var(--clr-grey-1);
    padding: 0.2rem;
    outline: 0;
    color: var(--clr-grey-1);

    transition: border-color 0.2s;
  }
  .match-result {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
  }
  .column-3 {
    width: 33%;
    text-align: center;
  }
  .first-column {
    text-align: left;
  }
  .final-column {
    text-align: right;
  }
  .input-text-field {
    background: transparent;
    height: 2rem;
    width: 1.2rem;
    border: 0;
    border-bottom: 1px solid var(--clr-grey-1);
    outline: 0;
    color: var(--clr-grey-1);
    text-align: center;
    transition: border-color 0.2s;
    font-size: 24px;
  }

  .input-text-field-big {
    background: transparent;
    height: 2rem;
    width: 100%;
    border: 0;
    border-bottom: 1px solid var(--clr-grey-1);
    outline: 0;
    color: var(--clr-grey-1);
    text-align: left;
    transition: border-color 0.2s;
    font-size: 16px;
  }
  .links-picks {
    width: 100%;
  }
  p {
    font-size: 16px;
  }
  .draft-link a {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 1rem;
  }
  .background-video {
    width: 100%;
    height: 80vh;
    object-fit: cover;
    position: absolute;
    z-index: -1;
  }
  .container {
    margin-top: 8rem;
    width: 100%;

    position: absolute;
    display: flex;
    justify-content: center;
  }

  .breadcrumb {
    width: 60%;
    top: -6rem;
    left: 4rem;
    position: absolute;
    .separator {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  .draft {
    width: 95%;
    position: absolute;
    display: flex;
    justify-content: space-around;
  }

  .column {
    //width: 34%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .map-turns {
    display: flex;
  }

  .draft-turn {
    margin: 0.2rem;
  }

  h2 {
    margin-top: 4rem;
  }
`;

export default MatchDraft;
